import React from 'react';

import SvgIcon from '../SvgIcon';

const IconStartRecording = (props: React.SVGAttributes<SVGSVGElement>) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <circle cx="10" cy="10" r="8" fill="transparent" stroke="currentColor" />
    <circle cx="10" cy="10" r="4" fill="currentColor" />
  </SvgIcon>
);

export default IconStartRecording;
